import { createSlice, PayloadAction } from '@reduxjs/toolkit'

//authority -1:未登录 0:大众 1:专家 2:管理员
interface LoginState {
  token: string
  userId: string
  authority: number
}

const initialState: LoginState = {
  token: '',
  userId: '',
  authority: 0
}

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload
    },
    setAuthority: (state, action: PayloadAction<number>) => {
      state.authority = action.payload
    }
  }
})
export const { setToken, setUserId, setAuthority } = loginSlice.actions
export default loginSlice.reducer
